var AppDispatcher = require('../core/AppDispatcher.jsx');
var ActionTypes = require('../constants/CongratulationsConstants.js').ActionTypes;
var Api = require('../apis/CongratulationsApi.js');

module.exports = {
    downloadAll: function(formModel, productCode){
        AppDispatcher.dispatch({
            actionType: ActionTypes.DOWNLOAD_ALL
        });
        Api.downloadAll(formModel, productCode);
    },
    downloadFile: function(formModel, productCode, formId){
        Api.downloadFile(formModel, productCode,formId);
    },
    clearDownload: function(){
        AppDispatcher.dispatch({
            actionType: ActionTypes.CLEAR_DOWNLOAD
        });
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/CongratulationsActions.js